/**
 * Prazo de checklist: o banco guarda MINUTOS; a tela mostra valor + unidade.
 *
 * A unidade é escolha de APRESENTAÇÃO — nada aqui trafega para a API. Ao abrir
 * um valor gravado, escolhemos a unidade que deixa o número inteiro e menor:
 * 1440 abre como "1 dia", 120 como "2 horas", 90 como "90 minutos" (porque
 * "1,5 horas" seria pior de ler e de editar que 90).
 */
export type DueUnit = 'minutes' | 'hours' | 'days';

const MINUTOS_POR_HORA = 60;
const MINUTOS_POR_DIA = 1440;

export function splitDueMinutes(minutes: number): { value: number; unit: DueUnit } {
  if (minutes % MINUTOS_POR_DIA === 0) return { value: minutes / MINUTOS_POR_DIA, unit: 'days' };
  if (minutes % MINUTOS_POR_HORA === 0) return { value: minutes / MINUTOS_POR_HORA, unit: 'hours' };
  return { value: minutes, unit: 'minutes' };
}

export function toDueMinutes(value: number, unit: DueUnit): number {
  if (unit === 'days') return value * MINUTOS_POR_DIA;
  if (unit === 'hours') return value * MINUTOS_POR_HORA;
  return value;
}

/** Opções do select, na ordem que a tela mostra. */
export const DUE_UNIT_OPTIONS: Array<{ value: DueUnit; label: string }> = [
  { value: 'minutes', label: 'Minutos' },
  { value: 'hours', label: 'Horas' },
  { value: 'days', label: 'Dias' },
];
